import React, { useEffect } from 'react'
import { getTranslation, getDataByKey, getData, renderData, sortByInt } from '../../../../helpers'
import { useFetch } from '../../../../hooks'
import Container from '../../../../components/Container'
import FakeLoaderBox from '../../../../components/FakeLoaderBox'
import Box from '../../../../components/Box'
import { BoxItem, BoxItemText } from '../../../../components/Box/styled'
import Boxes from '../../../../components/Boxes'
import Icon from '../../../../components/Icon'
import HeadBar from '../../../../modules/HeadBar'
import InfoBar from '../../../../modules/InfoBar'
import { StyledHerdGrp } from './styled'
import Modal from '../../../../components/Modal'
import FormAddCow from '../../components/FormAddCow'
import { Store } from '../../../../context/store'
import { isEmpty } from 'ramda'
import { useLocation } from 'react-router-dom'

const HerdGrp = () => {
    const { state: { refetch = false } = {} } = useLocation();
    const { actions } = Store();
    const { response, error, fetching, doFetch } = useFetch({
        url: '/herdgrp',
        method: 'GET'
    })

    const sortBoxes = sortByInt({ direct: 'asc', key: 'order' })

    useEffect(() => {
        if (refetch) doFetch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch])

    useEffect(() => {
        const groupsList = getDataByKey(response, "data", []);
        if (!isEmpty(groupsList)) {
            actions.setGroupsList(sortBoxes(groupsList));
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response])

    const renderDataState = renderData({ data: response, error, fetching })

    return (
        <StyledHerdGrp>
            <HeadBar
                title={getDataByKey(response, 'title', '')}
            >
                <Modal
                    renderOpenButton={
                        ({ handleToggleIsOpenModal }) => (
                            <Icon onClick={handleToggleIsOpenModal} name='add' pointer />
                        )
                    }
                >
                    {
                        ({ handleToggleIsOpenModal }) => (
                            <FormAddCow
                                doFetchHerd={doFetch}
                                onClickCancel={handleToggleIsOpenModal}
                            />
                        )
                    }
                </Modal>
            </HeadBar>
            <InfoBar
                lastUpdate={response.lastUpdate}
                translation={{ info: getTranslation(response, 'info') }}
            />
            <Container>
                {
                    renderDataState({
                        fetching: () => (<Boxes><FakeLoaderBox numberItems={3} /></Boxes>),
                        error: error => (<div>{error.toString()}</div>),
                        data: data => (
                            <Boxes>
                                {
                                    sortBoxes(getData(data))
                                        .map(box => (
                                            <Box
                                                key={box.label}
                                                to={{
                                                    pathname: `/manage/herdgrp/${box.label}`,
                                                    state: {
                                                        grpid: box.grp_id
                                                    }
                                                }}
                                                title={box.title}
                                                active={box.showme}
                                                bordercolor={box.bordercolor}
                                                info={box.info}
                                                autoHeightContent
                                                noMarginConent
                                                content={
                                                    <>
                                                        {
                                                            box.herd !== null &&
                                                            <BoxItem>
                                                                <Icon name='herd_no_fill' height={24} width={24} />
                                                                <BoxItemText>{box.herd}</BoxItemText>
                                                            </BoxItem>
                                                        }
                                                        {
                                                            box.no_sensors !== null &&
                                                            <BoxItem>
                                                                <Icon name='no_sensors' height={24} width={24} />
                                                                <BoxItemText>{box.no_sensors}</BoxItemText>
                                                            </BoxItem>
                                                        }
                                                        {
                                                            box.grace_period !== null &&
                                                            <BoxItem>
                                                                <Icon name='grace_period' height={24} width={24} />
                                                                <BoxItemText>{box.grace_period}</BoxItemText>
                                                            </BoxItem>
                                                        }
                                                        {
                                                            box.tail_sensors !== null &&
                                                            <BoxItem>
                                                                <Icon name='tail_sensors' height={24} width={24} />
                                                                <BoxItemText>{box.tail_sensors}</BoxItemText>
                                                            </BoxItem>
                                                        }
                                                    </>
                                                }
                                            />
                                        ))
                                }
                            </Boxes>
                        )
                    })
                }
            </Container>
        </StyledHerdGrp >
    )
}

export default HerdGrp